import * as THREE from 'three';
import { ft } from './units.js';

/**
 * One directional key plus ambient fill, per the greybox rules. Nothing else.
 *
 * The shadow frustum has to cover the whole property, because the property is
 * one continuous space with no loading screens and therefore no opportunity to
 * re-aim the light. That means a wide frustum on a fixed map size, and a bias
 * tuned for it — a tighter frustum would look better and would also mean
 * shadows that vanish once you walk to the far end of the corridor.
 */
export function createLights() {
  // Ambient is doing more work than it normally would. Interiors are lit
  // through their own ceilings (see `build.js`), which gets light into the
  // rooms but not into the corners a bounce would reach, so the fill has to
  // carry them.
  const ambient = new THREE.AmbientLight(0x9fa8bd, 2.2);

  // Steep, so wall shadows are short. A low sun through a building made of
  // interior walls draws forty-foot shadows across rooms it is not in.
  const key = new THREE.DirectionalLight(0xfff4e2, 1.7);
  key.position.set(ft(40), ft(200), ft(-60));
  key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  key.shadow.camera.near = 1;
  key.shadow.camera.far = ft(400);
  const span = ft(130);
  key.shadow.camera.left = -span;
  key.shadow.camera.right = span;
  key.shadow.camera.top = span;
  key.shadow.camera.bottom = -span;
  key.shadow.bias = -0.0009;

  ambient.name = 'ambient';
  key.name = 'sun';
  return [ambient, key];
}
